<template>
        <v-dialog
        fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
        v-model="show"
      >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
            <v-btn
            icon
            dark
            @click="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
            {{$t("offlineImages.dialog.header")}}
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col
                        v-for="item in pendingOfflineUploadImages"
                        :key="item.assembleStepId"
                        cols="6"
                        >
                        <v-img
                            :src="'data:image/jpeg;base64,' + item.image"
                        >
                            <template v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                                ></v-progress-circular>
                            </v-row>
                            </template>
                        </v-img>
                        <v-row align="center" class="text--primary">{{item.date}}</v-row>
                        </v-col>
                    </v-row>
                </v-container>            
                </v-card-text>
          </v-card>
        </v-dialog>
</template>


<script>
// eslint-disable-next-line no-unused-vars
import api from "../../../api/flexiapp";
import BaseModule from "../../common/BaseModule"; 
import pictureManager from "../../common/PictureManager";

export default {
  name: "OfflineImagesDialog",
  mixins: [BaseModule],
  components: {},
  data() {
    return {
      show: false,
      isLoading: false,
      pendingOfflineUploadImages : [],
    };
  },
  computed: {
      badgeCount(){
            return this.$store.state.flexiapp.pendingOfflineUploadImageCount;
        }
    },
  methods: {
      showDialog() {
        window.$vue.$off('ne_backbutton');
        window.$vue.$on('ne_backbutton', this.processBackButton);
        this.$nextTick(() => {
              this.listarItems();
        });
        this.show = true;
    },
      listarItems: function () {
      this.pendingOfflineUploadImages = [];
      this.isLoading = true;
      //Function needed??? is it goind to use watch?
      this.pendingOfflineUploadImages = pictureManager.getQueue();
      },
        processBackButton: function() {
            window.$vue.$off('ne_backbutton');
            this.show = false;
        }
   },
  watch: {
      // eslint-disable-next-line no-unused-vars
      badgeCount (newCount, oldCount) {
            this.listarItems();
      }
  },
  beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.listarItems();
      })
    }
};
</script>
